import Button from '@orn/shared-web/components/Button/Button';

import FreeTrialInfo from '../../FreeTrialInfo';
import LegalLinks from '../../LegalLinks';
import { OnboardingTitle } from '../../OnboardingLayout';

import type { IOnboardingStepProps } from '../types';

const ANNUAL_PRICE_LABEL = '$99/year';
const ANNUAL_PRICE_SUBTITLE = 'after your 30-day free trial';

/**
 * Onboarding payment screen — "Start your free trial." Surfaces the cost
 * (`$99/year`), reuses {@link FreeTrialInfo} for the day-0 / day-21 / day-30
 * lifecycle explainer, and exposes an always-enabled CTA that advances the
 * wizard. The payment-method selector from the Figma frame is intentionally
 * omitted: no payment processor is wired up yet, so collecting card details
 * here would just route into a stub.
 *
 * Figma: Mantle - UX/UI, node 4174:72376 "Onboarding Step 15".
 */
const PaymentStep = ({ onNext, onBack }: IOnboardingStepProps) => {
  return (
    <div className="flex w-full flex-col gap-6">
      <OnboardingTitle
        title="Start your free trial"
        subtitle="Try Mantle free for 30 days. Cancel anytime."
        onBack={onBack}
      />

      <div className="flex w-full flex-col gap-6">
        <div className="bg-utility-brand-100 border-utility-brand-500 flex w-full flex-col items-center justify-center gap-2 rounded-xl border px-4 py-5">
          <p className="text-text-primary text-display-lg font-display font-medium">{ANNUAL_PRICE_LABEL}</p>
          <p className="text-text-tertiary text-sm">{ANNUAL_PRICE_SUBTITLE}</p>
        </div>

        <FreeTrialInfo className="w-full" />
      </div>

      <div className="flex w-full flex-col items-center gap-5">
        <Button type="button" size="xl" color="quaternary" className="w-full" onClick={onNext}>
          Start Free Trial
        </Button>
        <p className="text-tertiary text-xs">
          By starting your trial, you agree to Mantle&apos;s <LegalLinks />.
        </p>
      </div>
    </div>
  );
};

PaymentStep.displayName = 'PaymentStep';

export default PaymentStep;
